import { Configuration } from './types';

type GetConfig = <T extends Configuration>(configuration?: T) => () => T | undefined;

export const getConfig: GetConfig = (configuration) => () => configuration;
